import { render, staticRenderFns } from "./GoogleButton.vue?vue&type=template&id=ba015a1a&scoped=true"
import script from "./GoogleButton.vue?vue&type=script&lang=js"
export * from "./GoogleButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleButton.vue?vue&type=style&index=0&id=ba015a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba015a1a",
  null
  
)

export default component.exports